import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money, shortDate, type EntrySummary } from "../api";
import { ErrorNotice, Loading } from "../ui";
import { useUpload } from "./upload";

export function Inbox() {
  const [entries, setEntries] = useState<EntrySummary[] | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [over, setOver] = useState(false);
  const { upload, busy, error: uploadError } = useUpload();

  useEffect(() => {
    api.get<EntrySummary[]>("/api/entries?status=draft").then(setEntries).catch(setError);
  }, []);

  const choose = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "application/pdf,image/jpeg,image/png,image/heic";
    input.onchange = () => input.files?.[0] && upload(input.files[0]);
    input.click();
  };

  return (
    <div className="stack" style={{ "--gap": "24px" } as React.CSSProperties}>
      <div>
        <h1>To review</h1>
        <p className="muted">Check what we read from each document, choose what it's for, and save.</p>
      </div>
      <div
        className={`dropzone${over ? " over" : ""}`}
        role="button"
        tabIndex={0}
        onClick={choose}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && choose()}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          const file = e.dataTransfer.files[0];
          if (file) void upload(file);
        }}
      >
        {busy ? "Uploading and reading…" : <>Drop a receipt, invoice or statement here, or <u>choose a file</u><br /><span className="small">PDF, JPEG, PNG or HEIC</span></>}
      </div>
      <ErrorNotice error={uploadError ?? error} />
      {!entries ? <Loading /> : entries.length === 0 ? (
        <div className="card flat empty">Nothing waiting. Upload a receipt above to get started.</div>
      ) : (
        <div className="card list-card list">
          {entries.map((e) => (
            <Link key={e.id} to={`/inbox/${e.id}`} className="list-item">
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600 }}>{e.supplier ?? "Unknown supplier"}</div>
                <div className="muted small">{shortDate(e.date)} · {e.categoryName ?? "No category yet"}</div>
              </div>
              <span className="amount">{money(e.amountCents)}</span>
              <span aria-hidden className="muted">›</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
